export enum ObserveResponse {
  Body = 'body',
  Response = 'response',
  Event = 'event'
}
